// src/components/AdminRoute/AdminRoute.js
// Protège les pages réservées aux administrateurs.
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function AdminRoute({ children }) {
  const { isLoggedIn, isAdmin, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div style={{ paddingTop: 'var(--navbar-h)' }}><div className="spinner" /></div>;
  }

  if (!isLoggedIn) {
    return <Navigate to="/connexion" state={{ from: location }} replace />;
  }

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return children;
}
